<div class="custom-group-comp">
  <client-search [loaderImage]="''" [selectedAdminPlan]="selectedAdminPlan()"
    [features]="['basic', 'advanced']" (resetSelected)="resetOrClientSelected()">
  </client-search>
  @if (!selectedSubClients().length) {
  <client-search-results disableInactive [hideContentOnNoResults]="true"
    (subClientSelected)="subClientSelected($event)" (clientSelected)="resetOrClientSelected()">
  </client-search-results>
  }
  @if (selectedSubClients().length > 0) {
  <div class="custom-group-inputs">
    <form [formGroup]="customGroupForm" (ngSubmit)="onCustomGroupSubmitted(0)">
      <rs-input formControlName="fromDate" type="date" strictDateTyping placeholder="MM/DD/YYYY" label="From Date" validation="eager" min="1900-01-01"></rs-input>
      <rs-input formControlName="toDate" type="date" strictDateTyping placeholder="MM/DD/YYYY" label="To Date" validation="eager" min="1900-01-01"></rs-input>
      <rs-select formControlName="frequency" [items]="frequencyDropDown" label="Frequency" validation="eager"></rs-select>
      <button [disabled]="isFetching() || !customGroupForm.valid" rs-raised-button color="primary">Submit</button>
    </form>
  </div>
  }
  @if (isFetching()) {
  <rs-loader></rs-loader>
  }
  @if (customGroupError()) {
  <div class="custom-group-error">{{customGroupError()}}</div>
  }
  @if (showResults()) {
    @if (!isFetching()) {
    <table>
      <thead>
      <tr>
        <th>Group - subgroup</th>
        <th>Frequency</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Run Date</th>
        <th>View Reports</th>
      </tr>
      </thead>
      <tbody>
      @if (customGroupReports()?.pagination?.totalRecords) {
        @for (report of customGroupReports()?.reports; track report) {
        <tr>
          <td>{{report.clientSubClientId[0].clientSpecifiedId}} - <collapsable-column [content]="report.clientSubClientId[0].subClientSpecifiedIds.split(',')" [size]="2"></collapsable-column></td>
          <td>{{report.frequency}}</td>
          <td>{{report.startDate | date: 'MM/dd/yyyy'}}</td>
          <td>{{report.endDate | date: 'MM/dd/yyyy'}}</td>
          <td>{{report.date | date: 'MM/dd/yyyy'}}</td>
          <td>{{report.name}} <a (click)="selectedReport.emit({id: report.id, type: report.format})">{{'[' + report.format + ']'}}</a></td>
        </tr>
        }
      }
      </tbody>
    </table>
    }
    <rs-paginator showFirstLastButtons [length]="customGroupReports()?.pagination?.totalRecords || 0"
                  (page)="pageChanged($event)" [pageSize]="defaultPageSize"></rs-paginator>
  }
</div>
